import { useTranslation } from "react-i18next";
import { ElementNoteByline } from "./ElementNoteByline";
import {
  NOTE_CONTENT_MAX_LENGTH,
  NOTE_COUNTER_THRESHOLD,
  NOTE_FIELD_MIN_ROWS,
} from "./constants";
import type { ElementNoteProps } from "./types";

export const ElementNote = ({ canEdit, element, form }: ElementNoteProps) => {
  const { t } = useTranslation();

  const note = element.note;

  if (!canEdit && note === null) return null;

  return (
    <div className="pt-1">
      <div className="mb-1 text-sm font-medium text-gray-700">
        {t("smartSurveyor.elementDetails.note.title")}
      </div>
      {note !== null && <ElementNoteByline note={note} />}
      <form.AppField name="note">
        {(field) => (
          <field.TextareaField
            label={t("smartSurveyor.elementDetails.note.title")}
            isEditable={canEdit}
            placeholder={t("smartSurveyor.elementDetails.note.placeholder")}
            maxLength={NOTE_CONTENT_MAX_LENGTH}
            counterThreshold={NOTE_COUNTER_THRESHOLD}
            minRows={NOTE_FIELD_MIN_ROWS}
          />
        )}
      </form.AppField>
    </div>
  );
};
